import { Fragment, useMemo } from "react";

import { Element } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";
import { DnDBypassProvider, useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import { MidpathTCPAAnswerBlock } from "../..";
import BasePreview from "../../base";

function MidpathTCPAAnswersPreview(props) {
  const { data: { value: data } } = useDnDBypassContext()

  if (!data) return null

  const { answers, isMultipleAnswers } = data

  return <BasePreview {...props}>
    <ul className="tcpa-answers">
      {(answers || []).map((data, idx) => <TCPAAnswer key={idx} data={data} isMultipleAnswers={isMultipleAnswers} />)}
    </ul>
  </BasePreview>
}

function TCPAAnswer({ data, isMultipleAnswers }) {
  return <DnDBypassProvider data={useMemo(() => ({ isMultipleAnswers, ...data }), [data, isMultipleAnswers])}>
    <Element is={MidpathTCPAAnswerBlock} id={`tcpa-answer-${data.answer}`} />
  </DnDBypassProvider>
}

export default define('tcpa-answers', MidpathTCPAAnswersPreview, Fragment)
  .shared(prop.share('MidpathTCPAAnswers', 'tcpa-answers'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.appearance())
  .defaultProps({
    layoutType: "flex",
    flex: {
      gap: "3",
      align: "items-center",
      direction: "flex-col",
    },
  })
  .build()
